<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container">
        <div class="">
          <img src="../../assets/bongo/Group 3123.png" alt="" />
        </div>
        <div class="flex-right">
          <div class="upper">
            <img src="../../assets/bongo/“ (1).svg" alt="" />
            <div class="div" style="padding:20px 0"></div>

            <h3>
              “Becoming a designer is not only a profession, it is a lifestyle.
              You will get to see how imperfectly most of the things are
              designed around us and often how a small design change can make a
              large impact into the business. Hopefully, after finishing the
              workshop you will be able to be curious enough to see things
              around you with a designer's eye!”
            </h3>
            <div class="div" style="padding:20px 0"></div>
            <div class="" style="display:flex; justify-content:flex-end">
              <img
                src="../../assets/bongo/“ (2) (1).svg"
                alt=""
                style="text-align:right"
              />
            </div>
          </div>
          <div class="lower">
            <h2>
              Sashoto Seeam
            </h2>
            <h5>
              UX Researcher & Product Designer
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.credits {
  font: 400 0.75rem/1rem 'Manrope';
  color: #626367;
}
.inner-container {
  max-width: 1270px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-bottom: 100px;
}
.flex-right {
  display: flex;
  flex-direction: column;
}
.upper,
.lower {
  padding: 0 50px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.flex-right h3 {
  font: 400 1rem/1.2rem 'Manrope';
  color: white;
}
.upper {
  background-color: #d21e28;
}
.lower h2 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.lower h5 {
  font: 400 0.875rem/1rem 'Manrope';
  color: #29292b;
}

.lower {
  display: flex;
  flex-direction: column;
  background-color: white;
  flex-grow: 1;
}
.lower img {
  align-self: flex-end;
}
.video {
  width: 849px;
  height: 478px;
}
@media only screen and (max-width: 600px) {
  .inner-container {
    max-width: 1270px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    padding-bottom: 100px;
  }
  .video {
    width: 359px;
    height: 278px;
  }
  .upper img {
    padding-bottom: 25px;
  }
  .lower img {
    padding-top: 20px;
  }
}
</style>
